module.exports = __webpack_public_path__ + "static/arredo-4b92c827a98651b7c6988ded74eabfb8.jpg";